import { Menu } from '@mantine/core';
import { IconCheck, IconDeviceMobile, IconMoon, IconSun } from '@tabler/icons-react';
import type { ReactNode } from 'react';
import { THEME_CHOICES, themeChoiceLabel, useThemeChoice, type ThemeChoiceValue } from '@/theme/colorScheme';

const ICONS: Record<ThemeChoiceValue, (size: number) => ReactNode> = {
  auto: (s) => <IconDeviceMobile size={s} aria-hidden="true" />,
  light: (s) => <IconSun size={s} aria-hidden="true" />,
  dark: (s) => <IconMoon size={s} aria-hidden="true" />,
};

/** The three appearance choices as menu items (used in the theme button and the avatar menu). */
export function AppearanceMenuItems() {
  const { choice, setChoice } = useThemeChoice();
  return (
    <>
      <Menu.Label>Appearance</Menu.Label>
      {THEME_CHOICES.map((c) => {
        const on = c.value === choice;
        return (
          <Menu.Item
            key={c.value}
            leftSection={ICONS[c.value](18)}
            rightSection={on ? <IconCheck size={18} color="var(--proc-primary)" aria-hidden="true" /> : null}
            onClick={() => setChoice(c.value)}
            aria-current={on ? 'true' : undefined}
            fw={on ? 700 : 500}
          >
            {c.label}
            {on && <span className="sr-only"> (selected)</span>}
          </Menu.Item>
        );
      })}
    </>
  );
}

/** Signed-out header: a 48 px button that opens Match my phone / Light / Dark. */
export function ThemeMenu() {
  const { choice, scheme } = useThemeChoice();
  const icon = choice === 'auto' ? ICONS.auto(22) : scheme === 'dark' ? ICONS.dark(22) : ICONS.light(22);
  return (
    <Menu position="bottom-end" withinPortal width={230} offset={4}>
      <Menu.Target>
        <button type="button" className="proc-iconbtn" aria-label={`Appearance: ${themeChoiceLabel(choice)}`}>
          {icon}
        </button>
      </Menu.Target>
      <Menu.Dropdown>
        <AppearanceMenuItems />
      </Menu.Dropdown>
    </Menu>
  );
}
